// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"125f165e","72":"0b4238f7","235":"ff01b347","378":"3535f728","385":"67cafdb0","401":"42c6f5ba","732":"39dfd2f7","895":"93a51780"}[chunkId] + ".chunk.css";
};